module.exports = __webpack_public_path__ + "img/round1-bg.66c57fa6.png";